import { getUserPreferences } from "../api";
import { useQuery } from "@tanstack/react-query";
import useAuth from "@/hooks/useAuth";

export const useUserPreferences = () => {
  const authenticated = useAuth().authenticated;

  const { data, isLoading, error } = useQuery({
    queryKey: ["user-preferences"],
    queryFn: getUserPreferences,
    enabled: authenticated,

    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,

    staleTime: Infinity,
  });

  const response = data?.data || {};

  const notificationsSound = (response["notifications.sound"]?.value as {
    headlines: boolean;
    truth_social: boolean;
  }) || { headlines: false, truth_social: false };

  const sourceColors = (response["source.colors"]?.value as string[]) || [];

  return {
    isLoading,
    error,
    notificationsSound,
    sourceColors,
  };
};
